import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UiIcon, UiTooltip } from 'ui-components';
import { StyledLockedFreeSearchChip } from './LockedFreeSearchChip.styles';

const DEFAULT_ICON_COLOR = '#9CAEBB';
const HOVER_LOCK_COLOR = '#FFD666';
const HOVER_SEARCH_COLOR = '#0C395A';

const LockedFreeSearchChip = () => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const lockColor = isHovered ? HOVER_LOCK_COLOR : DEFAULT_ICON_COLOR;
  const searchColor = isHovered ? HOVER_SEARCH_COLOR : DEFAULT_ICON_COLOR;

  return (
    <UiTooltip
      title={t('common:freeSearchNoAccess')}
      placement='bottom'
      enterTouchDelay={0}
    >
      <StyledLockedFreeSearchChip
        className='locked-free-search-chip'
        data-testid='header-locked-free-search-chip'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <UiIcon
          className='locked-free-search-chip__search-icon'
          icon='ri-search-line'
          size={16}
          color={searchColor}
          hover={searchColor}
        />
        <span className='locked-free-search-chip__label'>
          <span>{t('layout:freeSearch')}</span>
          <UiIcon
            className='locked-free-search-chip__lock-icon'
            icon='ri-lock-line'
            size={20}
            color={lockColor}
            hover={lockColor}
          />
        </span>
      </StyledLockedFreeSearchChip>
    </UiTooltip>
  );
};

export default memo(LockedFreeSearchChip);
